import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import {
  DxTextAreaModule,
  DxTextBoxModule,
  DxButtonModule,
  DxToolbarModule,
  DxFileUploaderModule,
  DxValidationGroupModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Message, Messages } from 'src/app/types/messages';
import { UserAvatarComponent } from 'src/app/components/library/user-avatar/user-avatar.component';

@Component({
  selector: 'card-messages',
  templateUrl: './card-messages.component.html',
  styleUrls: ['./card-messages.component.scss'],
  imports: [
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxFileUploaderModule,
    DxButtonModule,
    DxValidationGroupModule,
    DxValidatorModule,
    UserAvatarComponent,
    CommonModule,
    TranslateModule,
  ]
})
export class CardMessagesComponent {
  @Input() user: string;

  @Input() items: Messages;

  private t = inject(TranslateService);

  messageTitle = '';

  messageText = '';

  /** Options del boton Send — DevExtreme no rebina pipes en options inline,
   *  asi que armamos el objeto via getter cacheado y reasignado en onLangChange. */
  sendButtonOptions = this.buildSendOptions();

  private buildSendOptions() {
    return {
      text: this.t.instant('crmContacts.cols.send'),
      stylingMode: 'contained' as const,
      type: 'default' as const,
      onClick: (e: any) => this.send(e),
    };
  }

  constructor() {
    this.t.onLangChange.subscribe(() => {
      this.sendButtonOptions = this.buildSendOptions();
    });
  }

  getAvatarText(name: string) {
    return name.split(' ').map((name) => name[0]).join('');
  }

  getText(data: Message) {
    return data.text.replace('{username}',  data.manager !== this.items[0].manager ? this.items[0].manager : this.items[1].manager);
  }

  send = (e) => {
    if (!e.validationGroup.validate().isValid) {
      return;
    }

    const newMessage: Message = {
      subject: this.messageTitle,
      text: this.messageText,
      manager: this.user,
      date: new Date(),
    };

    this.items.push(newMessage);

    e.validationGroup.reset();
  };
}
